// extracted by mini-css-extract-plugin
export default {"descriptionList":"DescriptionList-descriptionList-o7bt3"};